import axios from "axios";
const createDoc5 = async (values: {
  pathFile: string;
  sendBy: string;
  kpi: [];
  group: [];
  teacher: [];
  upload: any;
  doc3Id: number;
}) => {
  const checkField = (array: [], key: string) => {
    //เอา คีย์ไปค้น ถ้าเจอ ก็ตอบ ture ไม่เจอก็ false
    return array.find((x) => x === key) ? true : false;
  };

  /*
  pathFile : string
  sendBy : string
  kpi1 : boolean  checkField(values.kpi,"kpi1")
  kpi2: boolean checkField(values.kpi,"kpi2")
  kpi3: boolean checkField(values.kpi,"kpi3")
  kpi4: boolean checkField(values.kpi,"kpi4")
  group: string[]
  teacher: string[]
  doc3 : number
  */

  // console.log(values);

  const data = {
    pathFile: values.upload[0].response.filename,
    kpi1: checkField(values.kpi, "kpi1"),
    kpi2: checkField(values.kpi, "kpi2"),
    kpi3: checkField(values.kpi, "kpi3"),
    kpi4: checkField(values.kpi, "kpi4"),
    sendBy: values.sendBy,
    group: values.group.toString(),
    teacher: values.teacher.toString(),
    doc3: values.doc3Id,
    kpi: values.kpi.toString(),
  };
  // console.log(data);

  return await axios.post("doc5", data);
};

const getByDoc3 = async (doc3Id: number) => {
  return await axios.get(`doc5/${doc3Id}`);
};

const checkStatusSend = async (doc3Id: number, group: string) => {
  const data = encodeURIComponent(group);
  return await axios.get(`doc5/${doc3Id}?group=${data}`);
};

const delele = async (id: number) => {
  return await axios.delete(`doc5/${id}`);
};

const Doc5Service = { createDoc5, getByDoc3, checkStatusSend, delele };
export default Doc5Service;
